import React from 'react';
import CardButton from '../CardButton/CardButton';
import './MilestoneSlide.css';
import { cosmosTrackService } from '../../../../../cosmosTracking/cosmosTrackService';
import {view_all_milestone} from '../../../../../cosmosTracking/cosmosEvents';
import Lottie from "react-lottie";
import mileStoneAnimation from "../../../Resources/Slides/indipendence/win-special-prizw.json";

function MilestoneSlide(props) {
	const { data, } = props;
	console.log('dataaa',data);
	const mileStoneAnimationLottie = {
		loop: true,
		autoplay: true,
		animationData: mileStoneAnimation,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice',
		},
	};
	return (
		<>
		<div className="slideCard slideCardMileStone">
			<div className="cardHeader">
				<Lottie options={mileStoneAnimationLottie} height={128}></Lottie>
			</div>
			<div className="cardContent">
				<div className="mileStoneData">
					<img src={data?.peakDay?.mileStones?.mileStoneData?.imgUrl} alt="img" />
				</div>
				<CardButton text={'View All Milestones'}
							className={'btn-action'}
							eventCallback={() => {cosmosTrackService(view_all_milestone);}}
							deeplink={data?.deeplink}
				/>
			</div>
		</div>
		</>
	);
}

export default MilestoneSlide;

